import BaseService from 'common/services/base-service';
import { login } from 'common/util/forms/atgAjaxHelper';
import { buildSubscription, updateSubscriptions } from 'common/services/notification-service';
import { fetchConnectedGearhead } from 'common/services/community-service';

class LoyaltyService extends BaseService {
  constructor() {
    super('loyalty-service');
  }

  subscribe = (email, pass, birthday, agree, recaptcha, skipLogIn, source) => {
    const logIn = (email, pass, recaptcha, skipLogIn) => {
      if (skipLogIn) return Promise.resolve({ success: true });
      const formInfo = login(email, pass, false);

      formInfo.data.push({
        name: 'g-recaptcha-response',
        value: recaptcha,
      });

      return this.doRequest({
        type: 'POST',
        url: formInfo.url,
        data: formInfo.data,
      })
        .then((result) => {
          if (!result.success &&
            result.formExceptions &&
            result.formExceptions[0].message.includes('You are already logged in')) {
            return { success: true };
          } else {
            return result;
          }
        });
    };

    if (!skipLogIn && !(email && pass)) return Promise.resolve({ shouldReload: false });

    if (!agree) return Promise.resolve({ shouldReload: false });

    return logIn(email, pass, recaptcha, skipLogIn)
      .then(result => this._updateLoyaltySubscription(result, birthday, source));
  };

  _updateLoyaltySubscription = (result, birthday, source) => {
    if (!result.success) {
      return result;
    }

    const { day, month, year } = birthday;
    const validBirthday = (day > 0 && month > 0 && year > 0) ? birthday : undefined;

    return new Promise((resolve, reject) => {
      updateSubscriptions([buildSubscription('Loyalty', true)], validBirthday, source)
        .then(r => resolve({ ...result, ...r, shouldReload: true }))
        .fail((error) => {
          const hasErrorsProperty = error.responseJSON && error.responseJSON.errors;
          const doesLoyaltySubscriptionFailed = hasErrorsProperty ? error.responseJSON.errors.indexOf('Loyalty') !== -1 : false;

          if (error.status === 300 && !doesLoyaltySubscriptionFailed) {
            resolve({ success: true, shouldReload: true });
          } else {
            reject(error);
          }
        });
    });
  };

  isCustomerConnected = () => {
    if (BC.user.isLoggedIn) {
      return fetchConnectedGearhead()
        .then(result => result.hasOwnProperty('userId'));
    }

    return Promise.resolve(false);
  };

  getLoyaltyProgramInfo = () => this.doRequest({
    type: 'GET',
    url: '/Store/services/customer/subscriptions/loyalty',
  });

  getLocalStorageLoyaltyProgramInfo = () => {
    const storageKey = `loyalty_${BC.profile.id}`;
    const storedData = localStorage.getItem(storageKey);

    if (storedData != null) {
      try {
        const jsonData = JSON.parse(storedData);
        const expiry_time = jsonData.expiry_time;

        if (expiry_time && expiry_time > new Date().getTime()) {
          return jsonData;
        }
      } catch (exception) {
        $.error('clearing local storage due to invalid json');
      }
      localStorage.removeItem(storageKey);

      return null;
    } else {
      return null;
    }
  };

  sendLoyaltyCreditsEvent = (data) => {
    const event = document.createEvent('CustomEvent');

    event.initCustomEvent('loyaltyCreditsEvent', true, true, data);
    document.dispatchEvent(event);
  };

  getCachedLoyaltyProgramInfo = () => {
    const storedData = this.getLocalStorageLoyaltyProgramInfo();

    if (storedData == null) {
      return this.getLoyaltyProgramInfo()
        .then((response) => {
          const tomorrow = new Date();

          tomorrow.setDate(tomorrow.getDate() + 1);
          response.expiry_time = tomorrow.getTime();
          localStorage.setItem(`loyalty_${BC.profile.id}`, JSON.stringify(response));
          this.sendLoyaltyCreditsEvent(response);

          return response;
        });
    } else {
      this.sendLoyaltyCreditsEvent(storedData);

      return Promise.resolve(storedData);
    }
  };
}

export default LoyaltyService;
